import React from 'react';
export function AlertHeader() {
  const messages = ['🔥 50% OFF — Oferta por tiempo limitado', '⚡ Últimos cupos disponibles al precio de lanzamiento', '📦 Descarga digital inmediata — Empiece hoy', '🛡️ Garantía de 7 días — Sin riesgo'];
  return <div className="bg-emerald-900 text-white py-2.5 overflow-hidden relative flex items-center" data-id="element-1">
      <style data-id="element-2">
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee {
            animation: marquee 25s linear infinite;
          }
          .animate-marquee:hover {
            animation-play-state: paused;
          }
        `}
      </style>
      <div className="flex whitespace-nowrap animate-marquee w-max" data-id="element-3">
        {/* First set of messages */}
        <div className="flex items-center justify-around min-w-full" data-id="element-4">
          {messages.map((msg, idx) => <span key={`msg-1-${idx}`} className="text-sm font-medium px-8" data-id="element-5">
              {msg}
            </span>)}
        </div>
        {/* Duplicated set for seamless loop */}
        <div className="flex items-center justify-around min-w-full" data-id="element-6">
          {messages.map((msg, idx) => <span key={`msg-2-${idx}`} className="text-sm font-medium px-8" data-id="element-7">
              {msg}
            </span>)}
        </div>
      </div>
    </div>;
}